import './ScheduleReportWindow.scss'
import {
    HeaderAction,
    HeaderActionsContainer,
    HeaderTitle,
    HeaderTitleContainer,
    HeaderTitleIcon,
    Modal,
    ModalBody,
    ModalHeader,
    ModalModeType
} from '../../../../../CommonComponents/modals/Modal'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import useReportWindow from '../../../hooks/useReportWindow';
import { useSmartPlacement } from '../../../../../CommonComponents/modals/hooks/useSmartPlacement';
import { CloseSvg, ContactTaskSvg, NotContactTaskSvg, NotSchedulesvg, ScheduleIconSvg, WindowResizeSvg, WindowRightSvg } from '../../../../../CommonComponents/svgs/Svgs';
import useForm from '../../../hooks/useForm';
import useSelectedGroupSatellite from '../../../hooks/useSelectedGroupSatellite';
import CustomToolTip from '../../../../../CommonComponents/CustomToolTip';
import useAssets from '../../../hooks/useAssets';
import { convertDecimalMinutesToMMSS } from '../../../../../../utils/commonFunctions';

const ScheduleReportWindow = () => {
    const { formData } = useForm()
    const { schedule } = useAssets()
    const { selectedGroupSatellite } = useSelectedGroupSatellite()
    const { windowStore, onReportModalChange } = useReportWindow()

    const modalId = 'schedule__report__modal'
    const targetId = 'schedule__report__button'

    const selectedSatellite = useMemo(() => selectedGroupSatellite?.satelliteId, [selectedGroupSatellite?.satelliteId])
    const allScheduleData = useMemo(() => schedule?.data || {}, [schedule?.data])
    const selectedSchedule = useMemo(() => selectedSatellite ? allScheduleData[selectedSatellite] : [], [allScheduleData, selectedSatellite])

    const simulationStartTime = useMemo(() => formData?.schedule?.simulationStartTime, [formData?.schedule?.simulationStartTime])
    const simulationDuration = useMemo(() => formData?.schedule?.simulationDuration, [formData?.schedule?.simulationDuration])

    const windowSize = useMemo(() => windowStore.modals.scheduleReport.windowSize, [windowStore.modals.scheduleReport.windowSize])
    const { open, pinned, zIndex, position } = useMemo(() => windowStore.modals.scheduleReport, [windowStore.modals.scheduleReport])

    const { top, left, bottom, right } = useSmartPlacement(
        targetId,
        modalId,
        "top",
        open,
        pinned,
        {
            top: position.top,
            right: position.right,
            bottom: position.bottom,
            left: position.left
        }
    );

    const [openScheduleDetails, setOpenScheduleDetails] = useState<any>({
        'Schedule': false,
        'Not_Schedule': false
    })

    const [scheduleTaskDate, setScheduleTaskData] = useState<any>({
        'Schedule': [],
        'Not_Schedule': [],
    })
    const scrollRef = useRef<HTMLButtonElement | null>(null)
    const containerRef = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        if (containerRef.current && scrollRef.current) {
            const scrollRefCurrent = scrollRef.current as HTMLButtonElement;
            (containerRef.current as HTMLDivElement).scrollTop = scrollRefCurrent.offsetTop - containerRef.current.offsetHeight / 2;
        }
    }, [openScheduleDetails])

    const get_command_time = (epoch: any) => {
        const date = epoch && new Date(epoch)?.toISOString()?.split('T')?.[1]?.split('.')?.[0]
        return date
    }


    useEffect(() => {
        if (selectedSchedule?.length > 0 && simulationStartTime && simulationDuration) {
            let schedule_task_data: any = []
            let not_schedule_task_data: any = []

            let start_time = simulationStartTime
            let end_time = start_time + (simulationDuration as number * 60)

            let scheduleTaskCount = 0
            let not_scheduleTaskCount = 0
            let conflictTaskCount = 0

            selectedSchedule?.forEach((data) => {
                if (data?.status === 'Scheduled') {
                    scheduleTaskCount += 1
                    schedule_task_data = [...schedule_task_data, data]
                }
                else if (data?.status === 'Not Scheduled' || data?.status === 'Not Possible') {
                    not_scheduleTaskCount += 1
                    if (data?.startTime >= start_time && data?.endTime <= end_time) {
                        schedule_task_data = [...schedule_task_data, data]
                    } else {
                        not_schedule_task_data = [...not_schedule_task_data, data]
                    }
                }
                else if (data?.status === 'Conflict') {
                    conflictTaskCount += 1
                    if (data?.startTime >= start_time && data?.endTime <= end_time) {
                        schedule_task_data = [...schedule_task_data, data]
                    } else {
                        not_schedule_task_data = [...not_schedule_task_data, data]
                    }
                }
            })

            setScheduleTaskData({
                'Schedule': schedule_task_data,
                'Not_Schedule': not_schedule_task_data,
            })
        } else {
            setScheduleTaskData({
                'Schedule': [],
                'Not_Schedule': [],
            })
        }
    }, [selectedSchedule, simulationStartTime, simulationDuration])


    const getScheduleTaskDisplayName = (schedule, onTooltip) => {
        const type = schedule?.['type'];
        let name = "";
        if (schedule?.['type'] === "Contact Task") {
            name = schedule?.['properties']?.['groundStationName'] || "";
        } else {
            name = schedule?.['properties']?.['payloadName'] || "";
        }
        return name.length > 10 && !onTooltip ? name.substring(0, 10) + "..." : name;
    };

    const getTaskTypeIcon = (taskType: string) => {
        if (taskType === 'Contact Task') {
            return <ContactTaskSvg />
        } else {
            return <NotContactTaskSvg />
        }
    }

    const getSimulationStartTime = useCallback(() => {
        return !isNaN(new Date(simulationStartTime).getTime()) ? new Date(simulationStartTime * 1000).toISOString().split('.')[0] : ''
    }, [simulationStartTime])

    const getSimulationEndTime = useCallback(() => {
        return !isNaN(new Date(simulationStartTime).getTime()) ? new Date(new Date(simulationStartTime * 1000).getTime() + (simulationDuration as number * 60 * 1000)).toISOString().split('.')[0] : ''
    }, [simulationStartTime, simulationDuration])

    const onClick = (e: React.MouseEvent, mode: ModalModeType) => {
        onReportModalChange(e, 'root', 'scheduleReport', mode)
    }

    return (
        <Modal id={modalId} open={open} pinned={pinned} className={`schedule__report__container`}
            style={{
                minWidth: `${position.width}%`,
                height: `${position.height}%`,
                top: top,
                right: right,
                bottom: bottom,
                left: left,
                zIndex: zIndex
            }}
            onClick={(e) => { onClick(e, 'focus') }}
        >
            <ModalHeader className='schedule__report__container__header'>
                <HeaderTitleContainer>
                    <HeaderTitleIcon>
                        <ScheduleIconSvg />
                    </HeaderTitleIcon>
                    <HeaderTitle>
                        SCHEDULE
                    </HeaderTitle>
                </HeaderTitleContainer>
                <HeaderActionsContainer>
                    <HeaderAction title={pinned ? 'Unpin' : 'Pin to Right'}
                        className={`${pinned && 'active'}`}
                        onClick={(e) => { onClick(e, 'pinned') }}
                    >
                        <WindowRightSvg />
                    </HeaderAction>
                    <HeaderAction title='Resize'
                        onClick={(e) => { onClick(e, 'resize') }}
                    >
                        <WindowResizeSvg size={windowSize} />
                    </HeaderAction>
                    <HeaderAction title='Close'
                        onClick={(e) => { onClick(e, 'close') }}
                    >
                        <CloseSvg />
                    </HeaderAction>
                </HeaderActionsContainer>
            </ModalHeader>
            <ModalBody className='overflow-hidden'>
                <div className='schedule__report__container__body' onMouseDown={(e) => e.stopPropagation()}>
                    <div className='schedule__table__header__container'>
                        <div className='schedule__table__header'>
                            <span className='d-flex align-items-center justify-content-start w-30'>Task</span>
                            <span className='d-flex align-items-center justify-content-center w-20'>Trigger Time</span>
                            <span className='d-flex align-items-center justify-content-center w-20'>Duration</span>
                            <span className='d-flex align-items-center justify-content-start w-20'>Geo Trigger</span>
                            <span className='d-flex align-items-center justify-content-start w-10'>Status</span>
                        </div>
                    </div>
                    <div className='schedule__table__body' ref={containerRef}>
                        <div className='task_schedule_separator_container mb-3'>
                            <div className='task_schedule_separator_border' />
                            <span className='task_schedule_label'>Simulation Start Time: {getSimulationStartTime()} UTC</span>
                            <div className='task_schedule_separator_border' />
                        </div>
                        {scheduleTaskDate?.['Schedule']?.length > 0 && scheduleTaskDate?.['Schedule'].map((schedule, i) => {
                            const isDisabled = schedule?.['status'] !== 'Scheduled'
                            const startTime = schedule?.startTime;
                            const endTime = schedule?.endTime;
                            const seqDuration = schedule?.seqDuration;

                            const duration =
                                startTime != null &&
                                endTime != null &&
                                endTime >= startTime
                                    ? convertDecimalMinutesToMMSS((endTime - startTime) / 60)
                                    : '--';

                            const formattedSeqDuration =
                                seqDuration != null && seqDuration >= 0
                                    ? convertDecimalMinutesToMMSS(seqDuration / 60)
                                    : null;
                            const durationText = formattedSeqDuration ? `${formattedSeqDuration} / ${duration}` : duration;
                            return (
                                <button
                                    ref={openScheduleDetails?.['Schedule'] === i ? scrollRef : null}
                                    disabled={isDisabled}
                                    key={i} className={`schedule__table__body__row ${openScheduleDetails?.['Schedule'] === i ? 'active' : ''}`}>
                                    <div className={`schedule__table__body__row__item ${isDisabled ? 'disabled' : ''} ${openScheduleDetails?.['Schedule'] === i ? 'active' : ''}`}
                                        onClick={() => {
                                            if (schedule?.['status'] === 'Scheduled') {
                                                setOpenScheduleDetails({
                                                    ...openScheduleDetails,
                                                    'Schedule': openScheduleDetails?.['Schedule'] === i ? false : i,
                                                })
                                            }
                                        }}
                                    >
                                        <div className='d-flex align-items-center justify-content-start w-30 p-0 gap-3'>
                                            {getTaskTypeIcon(schedule?.['type'])}
                                            <div className='d-flex justify-content-center flex-column w-75'>
                                                <span className='text-start text-truncate fs-16' title={schedule?.taskName}>{schedule?.taskName} </span>
                                                <span className={`text-truncate text-start ${schedule?.['status'] === 'Scheduled' ? 'color-atmos' : ''}`} title={schedule?.['type'] === 'Contact Task' ? schedule?.['properties']?.['groundStationName'] : schedule?.['properties']?.['payloadName']}>{schedule?.['type'] === 'Contact Task' ? schedule?.['properties']?.['groundStationName'] : schedule?.['properties']?.['payloadName']}</span>
                                            </div>
                                        </div>
                                        <div className='d-flex flex-column align-items-center justify-content-center w-20'>
                                            <span className='w-100 d-flex align-items-center justify-content-center gap-2'><span className='opacity-75'>ST: </span> <span>{schedule?.startTime && get_command_time(schedule?.startTime * 1000)}</span> <span className='opacity-75'>UTC</span> </span>
                                            <span className='w-100 d-flex align-items-center justify-content-center gap-2'><span className='opacity-75'>ET: </span> <span>{schedule?.endTime && get_command_time(schedule?.endTime * 1000)}</span> <span className='opacity-75'>UTC</span> </span>
                                        </div>
                                        <span className="d-flex align-items-center justify-content-center w-20">
                                            {schedule?.['status'] === 'Conflict' ? duration : durationText}          
                                         </span>
                                        <div className='d-flex flex-column align-items-start justify-content-start w-20'>
                                            <span className='opacity-75 w-100 text-truncate text-start'>{schedule?.geoTrigger}</span>
                                            <span className='w-100 text-truncate text-start' title={schedule?.['location']}>{schedule?.['location'] ? schedule?.['location'] : '--'}</span>
                                        </div>
                                        <span className='d-flex align-items-center justify-content-center w-10 cursor-pointer' style={{ pointerEvents: 'auto' }}>
                                            {schedule?.['status'] === 'Scheduled' &&
                                                <CustomToolTip title={schedule?.['message']} placement="top">
                                                    <span><img id='success' src={require("../../../../../../assets/images/svgs/success.svg").default} /></span>
                                                </CustomToolTip>
                                            }
                                            {schedule?.['status'] === 'Conflict' &&
                                                <CustomToolTip title={schedule?.['message']} placement="top">
                                                    <span><img id='conflict' src={require("../../../../../../assets/images/svgs/worning.svg").default} /></span>
                                                </CustomToolTip>
                                            }
                                            {(schedule?.['status'] === 'Not Scheduled' || schedule?.['status'] === 'Not Possible') &&
                                                <CustomToolTip title={schedule?.['message']} placement="top">
                                                    <span><NotSchedulesvg /></span>
                                                </CustomToolTip>
                                            }
                                        </span>
                                    </div>

                                    {openScheduleDetails?.['Schedule'] === i &&
                                        <div className='schedule__table__body__row__item__details'>
                                            <div className='d-flex w-100 flex-column gap-3'>
                                                <div className='schedule__item__details__header'>
                                                    <span className='d-flex align-items-center justify-content-start w-30'>Sub System</span>
                                                    <span className='d-flex align-items-center justify-content-start w-40'>Command</span>
                                                    <span className='d-flex align-items-center justify-content-start w-15'>Start Time</span>
                                                    <span className='d-flex align-items-center justify-content-end w-15'>Duration</span>
                                                </div>
                                                <div className='schedule__item__details__body'>
                                                    {schedule?.['commandsList']?.length > 0 && schedule?.['commandsList'].map((item, j) => (
                                                        <div key={j} className='schedule__item__details__body__row'>
                                                            <div className='schedule__item__details__body__row__item'>
                                                                <span className='d-flex align-items-center justify-content-start w-30 text-truncate'>{item?.['subsystem']}</span>
                                                                <div className='w-40 d-flex align-items-center justify-content-start schedule__command__cell'>
                                                                    <CustomToolTip title={item?.['name'] || ''} placement='top-start' className='schedule__command__name__tooltip'>
                                                                        <span className='schedule__command__name opacity-75'>{item?.['name']}</span>
                                                                    </CustomToolTip>
                                                                </div>
                                                                <span className='d-flex align-items-center justify-content-start w-15'>{get_command_time(item?.epoch * 1000)} {' UTC'}</span>
                                                                <span className='d-flex align-items-center justify-content-end w-15'>{item?.['duration']} sec</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </button>
                            )
                        })}
                        <div className='task_schedule_separator_container mb-3'>
                            <div className='task_schedule_separator_border' />
                            <span className='task_schedule_label'>Simulation End Time: {getSimulationEndTime()} UTC</span>
                            <div className='task_schedule_separator_border' />
                        </div>
                        {scheduleTaskDate?.['Not_Schedule']?.length > 0 && scheduleTaskDate?.['Not_Schedule'].map((schedule, i) => {
                            return (
                                <div key={i} className={`schedule__table__body__row `}>
                                    <div className={`schedule__table__body__row__item disabled`}>
                                        <div className='d-flex align-items-center justify-content-start w-30 gap-3 p-0'>
                                            {getTaskTypeIcon(schedule?.['type'])}
                                            <div className='d-flex justify-content-start flex-column w-75'>
                                                <span className='text-truncate text-start fs-16' title={schedule?.taskName}>{schedule?.taskName} </span>
                                                <span className='text-truncate text-start' title={getScheduleTaskDisplayName(schedule, 'onToolTip')}>{getScheduleTaskDisplayName(schedule, '')}</span>
                                            </div>
                                        </div>
                                        <div className='d-flex flex-column align-items-center justify-content-center w-20'>
                                            {schedule?.startTime && <span className='w-100 d-flex align-items-center justify-content-center gap-2'>
                                                <span className='opacity-75'>ST: </span>
                                                <span>{schedule?.startTime && get_command_time(schedule?.startTime * 1000)}</span>
                                                <span className='opacity-75'>UTC</span>
                                            </span>}
                                            {schedule?.endTime && <span className='w-100 d-flex align-items-center justify-content-center gap-2'>
                                                <span className='opacity-75'>ET: </span>
                                                <span>{schedule?.endTime && get_command_time(schedule?.endTime * 1000)}</span>
                                                <span className='opacity-75'>UTC</span>
                                            </span>}
                                            {(!schedule?.startTime || !schedule?.endTime) && <span className='w-100 d-flex align-items-center justify-content-center'>--</span>}
                                        </div>
                                        <span className='d-flex align-items-center justify-content-center w-20'>{(schedule?.['endTime'] && schedule?.['startTime']) ? `${convertDecimalMinutesToMMSS((schedule?.['endTime'] / 60) - (schedule?.['startTime'] / 60))}` : '--'}</span>
                                        <div className='d-flex flex-column align-items-center justify-content-start w-20'>
                                            <span className='opacity-75 w-100 text-truncate text-start'>{schedule?.geoTrigger}</span>
                                            <span className='w-100 text-truncate text-start' title={schedule?.['location']}>{schedule?.['location'] ? schedule?.['location'] : '--'}</span>
                                        </div>
                                        <span className='d-flex align-items-center justify-content-center w-10 cursor-pointer' style={{ pointerEvents: 'auto' }}>
                                            {schedule?.['status'] === 'Conflict' &&
                                                <CustomToolTip title={schedule?.['message']} placement="top">
                                                    <span><img id='conflict' src={require("../../../../../../assets/images/svgs/worning.svg").default} /></span>
                                                </CustomToolTip>
                                            }
                                            {(schedule?.['status'] === 'Not Scheduled' || schedule?.['status'] === 'Not Possible') &&
                                                <CustomToolTip title={schedule?.['message']} placement="top">
                                                    <span><NotSchedulesvg /></span>
                                                </CustomToolTip>
                                            }
                                        </span>
                                    </div>

                                    {openScheduleDetails?.['Not_Schedule'] === i &&
                                        <div className='schedule__table__body__row__item__details'>
                                            <div className='d-flex w-100 flex-column gap-3'>
                                                <div className='schedule__item__details__header'>
                                                    <span className='d-flex align-items-center justify-content-start w-20'>Sub System</span>
                                                    <span className='d-flex align-items-center justify-content-start w-40'>Command & Params</span>
                                                    <span className='d-flex align-items-center justify-content-center w-20'>Start Time</span>
                                                    <span className='d-flex align-items-center justify-content-end w-20'>Duration</span>
                                                </div>
                                                <div className='schedule__item__details__body'>
                                                    {schedule?.['commandsList']?.length > 0 && schedule?.['commandsList'].map((item, j) => (
                                                        <div key={j} className='schedule__item__details__body__row'>
                                                            <div className='schedule__item__details__body__row__item'>
                                                                <span className='d-flex align-items-center justify-content-start w-20 text-truncate'>{item?.['subsystem']}</span>
                                                                <div className='w-40 d-flex align-items-center justify-content-start schedule__command__cell'>
                                                                    <CustomToolTip title={item?.['name'] || ''} placement='top-start' className='schedule__command__name__tooltip'>
                                                                        <span className='schedule__command__name opacity-75'>{item?.['name']}</span>
                                                                    </CustomToolTip>
                                                                    <span className='opacity-75 schedule__command__separator'>|</span>
                                                                    <span className='color-atmos schedule__command__arg'>{item?.['arg1']}</span>
                                                                </div>
                                                                <span className='d-flex align-items-center justify-content-center w-20'>{get_command_time(item?.epoch * 1000)} {' UTC'}</span>
                                                                <span className='d-flex align-items-center justify-content-end w-20'>{item?.['duration']} sec</span>
                                                            </div>
                                                            <div className='schedule__item__details__body__separator' />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </div>
                            )
                        })}
                    </div>
                </div>
            </ModalBody>
        </Modal >

    )
}

export default ScheduleReportWindow
